import { getNomenclatures, getNomenclatureById } from './getNomenclatures'
import { getNomenclaturesOptions } from './getNomenclaturesOptions'
import { getNomenclaturesAvailableCount } from './getNomenclaturesAvailableCount'

export const NomenclaturesApi = {
    getNomenclatures,
    getNomenclaturesOptions,
    getNomenclatureById,
    getNomenclaturesAvailableCount,
}
